export default __webpack_public_path__ + "static/170-2061cb3146016b58a779ec325bd1c498.jpg";